import BaseEntity from "./BaseEntity"

export default BaseEntity;